export enum ComponentType {
  TBC = 'tbc',
  TC = 'tc',
  EXCHANGE = 'exchange'
}